<template>
  <base-layout
    :readOnly="readOnly"
    :value="labelValue"
    :label-width="labelWidth"
    :text-align="textAlign"
    :style-type="styleType"
    :label="label"
    :is-dipatch="isDipatch"
    :isHtml="true"
  >
    <el-upload
      slot="control"
      class="base-upload-input base-oss-upload-input"
      :action="action"
      :on-preview="handlePreview"
      :on-success="handleSuccess"
      :multiple="multiple"
      :on-remove="handleRemove"
      :show-file-list="showFileList"
      :file-list="fileList"
      :allowUploadType="allowUploadType"
      :data="uploadData"
      :headers="this.uploadHeards"
      :disabled="disabled"
      :before-upload="handleBeforeUpload"
      :list-type="listType"
    >
      <template v-if="showUploadBtn && fileList.length < this.max">
        <el-button  v-if="clickType == 'alink'" :disabled="disabled || fileList.length >= this.max" size="small" :type="type">{{this.linkText}}</el-button>
        <el-button v-else :disabled="disabled||fileList.length >= this.max" size="small" type="primary">点击上传</el-button>
      </template>
      <template v-else></template>
    </el-upload>
    <template slot="htmlShow">
      <div v-if="Array.isArray(this.value) && this.value.length > 0">
        <a class="m-r-10" v-for="item in this.value" :key="item.url" @click="handleUrl(item.url)">{{item.url}}</a>
      </div>
      <a v-else-if="this.value" @click="handleUrl(value)">{{this.value}}</a>
    </template>
    <multiline-dialog
      slot="dialog"
      ref="multiline-img-dialog"
      size= "small"
      title= "查看图片"
      @handleSave="closeImgContainer"
      >
        <el-row v-loading="imgLoading">
          <el-col :span="24">
            <img-container
              :imgUrlList="currentTemporaryUrl"
              :showNext="false"
              imgWidth="400px"
            ></img-container>
            <div class="t-c p-t-20">
              <span class="span-link m-b-5" 
              @click="getOssUploadUrl(currentUrl)">{{currentUrl}}</span>
            </div>
          </el-col>
        </el-row>
      </multiline-dialog>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import { handleEmitValue, upload } from "./../props-config";
import { formatImgUrl } from "src/filter/modules/img";
import * as conf from "src/store/conf";
import * as utils from "src/store/utils";
import ImgContainer from 'src/pages/components/factory-deal/module/img-container'
import axios from 'axios'
import qs from 'qs'

export default {
  name: "base-oss-upload",
  components: {
    baseLayout,
    ImgContainer
  },
  computed: {
    fileList: {
      get() {
        if (Array.isArray(this.value) === false) {
          if (!this.value) return [];
          return [{ name: this.value, url: this.value }];
        } else {
          return this.value;
        }
      },
      set(val) {
        if (val.length >= this.max) {
          this.isMax = true;
        }
        return val;
      }
    },
    labelValue() {
      // const array = this.value;
      // if (Array.isArray(array) && array.length > 0) {
      //   return `<a><span onclick="${() => {this.getOssUploadUrl(array[0].url, null, this)}}">点击下载</span></a>`;
      // } else if(array) {
      //   return `<a href="javascript: void(0);" onclick="${() => this.getOssUploadUrl(array, null, this)}">${array}</a>`
      // } else {
      //   return "";
      // }
    },
    action() {
      if(this.getParams().token) {
        this.uploadData.token = this.getParams().token
        return conf.COMMON_PIC_UPLOAD_OSS_BYTOKEN
      } else {
        return conf.COMMON_PIC_UPLOAD_OSS
      }
    }
  },
  props: {
    ...upload,
    type: {
      type: String,
      default: "text"
    },
    data: {
      type: Object,
      default: () => ({})
    },
    multiple: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 1
    },
    // action: {
    //   type: String,
    //   default: conf.COMMON_FILE_UPLOAD
    // },
    value: {
      type: [Array, String],
      default: () => []
    },
    isArray: {
      type: Boolean,
      default: true
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    allowUploadType: {
      type: Array,
      default: ()=>[]
    },
    clickType: {
      type: String,
      default: 'btn'
    },
    linkText : {
      type: String,
      default: '点击上传'
    },
    params: {
      type: Object,
      default: () => {}
    },
    getParams :{
      type: Function,
      default: () => ({})
    },
    showUploadBtn: {
      type: Boolean,
      default: true
    },
    showImgDailog: {
      type: Boolean,
      default: true
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    fullPath: { // 总Q质检用到
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: 'text'
    },
    urlPrefix: {
      type: String,
      default: ''
    },
  },
  mounted() {
  },
  methods: {
    handleUrl(value, name) {
      if(this.showImgDailog) {
        this.showImg(value)
      } else {
        this.getOssUploadUrl(value, name)
      }
    },
    closeImgContainer(cb) {
      this.currentTemporaryUrl = []
      this.currentUrl = ''
      cb()
    },
    async showImg(originUrl, isFullPath) {
      this.imgLoading = true
      let temUrl = ''
      if(!isFullPath) {
        temUrl = await this.getTemporaryUrlByBlob(originUrl)
      }
      this.imgLoading = false
      if(temUrl != false || isFullPath) {
        this.currentTemporaryUrl = []
        this.currentTemporaryUrl.push(temUrl || originUrl)
        console.log(this.currentTemporaryUrl)
        this.currentUrl = originUrl
        this.$refs['multiline-img-dialog'].handleIsShow(true);
      } else {
        this.$message({
          type: 'warning',
          message: '加载图片失败'
        })
      }
    },
    getTemporaryUrlByBlob(imgUrl) {
      return new Promise((resolve, reject) => {
        let urlPath = this.getParams().token ? conf.COMMON_FILE_OSS_SHOW_PIC_BYTOKEN : conf.COMMON_FILE_OSS_SHOW_PIC
        this.$http
          .get(
            urlPath,
            {
              params: {
                picPath: imgUrl,
                style: 'image/resize,w_600,h_600',
                token: this.getParams().token,
              },
              paramsSerializer: function(p) { //固定写法
                return qs.stringify(p, {arrayFormat: 'repeat'})
              },
              headers: {
                "AdminUserKey-Info": utils.getCookie("AdminUserKey"),
                "AdminUserToken-Info": utils.getCookie("AdminUserToken"),
                'Application-type': 'LC'
              },
              responseType: "blob",
            },
            {}
          )
          .then(async (response) => {
            const blob = response.data;
            let temporaryUrl = window.URL.createObjectURL(blob);
            resolve(temporaryUrl)
          })
          .catch(err => {
            resolve(false)
          })
      })
    },
    handleEmitValue,
    handleSetValue(array) {
      if (this.isArray === true) {
        this.$emit("input", array);
        this.handleEmitValue(array);
      } else {
        if (Array.isArray(array) && array.length > 0) {
          this.$emit("input", array[0].url);
          this.handleEmitValue(array[0].url);
        } else {
          this.$emit("input", "");
          this.handleEmitValue("");
        }
      }
    },
    handleBeforeUpload(file) {
          if(this.autoUpload) {
              return true
          } else { // 自定义上传 修改文件名
              const timeStamp = Date.now()
              let fileName = file.name || ''
              let copyFile;
              if(this.fullPath) {
                const ext = file.name.split('.').pop();  // 获取文件后缀 
                const newFileName = `${timeStamp}.${ext}` 
                copyFile = new File([file], newFileName, { type: file.type  });
              } else {
                copyFile = new File([file], `${timeStamp}_${fileName}`)
              }
              this.uploadFile(copyFile)
              return false
          }
      },
      uploadFile(file) {
          const formdata = new FormData()
          formdata.append('file', file)
          for (const key in this.uploadData) {
              if (Object.hasOwnProperty.call(this.uploadData, key)) {
                  formdata.append(key, this.uploadData[key])
              }
          }
          axios.post(this.action, formdata).then(res => {
              this.handleSuccess(res.data)
          }).catch((err) => {
              this.$message.error(err.message || '文件上传失败')
          })
      },
    handleSuccess(response, file, fileList) {
      const downFile = {
        name: response.data.picPath,
        url: this.urlPrefix +  response.data.picPath
      };
      if (this.isArray === true) {
        if (this.fileList.length >= this.max) {
          return false;
        }
        this.handleSetValue([...this.fileList, downFile]);
      } else {
        this.handleSetValue([downFile]);
      }
    },
    handleRemove(file, fileList) {
      const index = this.fileList.findIndex(item => item == file);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
      if (this.isArray === true) {
        this.handleSetValue(this.fileList);
      } else {
        this.handleSetValue([this.fileList[0]]);
      }
      // this.handleSetValue(fileList.map(item => {
      //     return item.response.data
      // }))
    },
    handlePreview(file, fileList) {
      // if (file.url) {
      //   window.open(formatImgUrl(file.url), "_blank");
      // } else {
      //   window.open(formatImgUrl(file.response.data.url), "_blank");
      // }
      if(this.showImgDailog) {
        this.showImg(file.url, this.fullPath)
      } else if(this.autoUpload) {
        this.showImg(file.url, true)
      } else {
        this.getOssUploadUrl(file.url, null, this)
      }
    },
    async getOssUploadUrl(fileUrl, _fileName) {
      if(!fileUrl || Array.isArray(fileUrl)) {
        return false;
      }
      let url = this.getParams().token ? conf.COMMON_FILE_OSS_SHOW_PIC_BYTOKEN : conf.COMMON_FILE_OSS_SHOW_PIC
      this.$http.get(url, {
        params: {
          picPath: fileUrl,
          token: this.getParams().token,
        },
        paramsSerializer: function(p) { //固定写法
          return qs.stringify(p, {arrayFormat: 'repeat'})
        },
        headers: {
          'AdminUserKey-Info': utils.getCookie('AdminUserKey'),
          'AdminUserToken-Info': utils.getCookie('AdminUserToken'),
          'Application-type': 'LC'
        },
        responseType: "blob"
      }, {
      }).then(response => {
        const disposition = response.headers['content-disposition'];
        const filenameMatch = disposition.split('filename=')
        const fileName = (filenameMatch && filenameMatch[1]) || 'download';
        const blob = response.data;
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");　　　　//生成一个a标签
        link.download = _fileName || fileName;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        // 移除
        document.body.removeChild(link);  
      }).catch(error => {
      })
    }
  },
  data() {
    return {
      imgLoading: false,
      currentTemporaryUrl: [],
      currentUrl: '',
      isMax: false,
      uploadData: {
        userId: 1,
        userName: 'SCM供应商',
        module: 'supplier',
      },
      uploadHeards: {
        'AdminUserKey-Info': utils.getCookie('AdminUserKey'),
        'AdminUserToken-Info': utils.getCookie('AdminUserToken'),
        'Application-type': 'LC'
      }
    };
  },
};
</script>

<style scoped lang="scss">
.m-r-10 {
  margin-right: 10px;
}
.base-oss-upload-input {
  display: flex !important;
}
.span-link {
  cursor: pointer;
  color: #20a0ff;
  border-bottom: 1px solid #20a0ff;
}
.m-b-5 {
  margin-bottom: 5px;
}
.t-c {
  text-align: center
}
.p-t-20 {
  padding-top: 10px;
}
</style>
